<template>
	<div>
		<b-card>
			<b-card-text class="w-100">
				<b-button :class="isDrillDown ? 'td-btn-blue' : 'td-btn-outline-blue'" pill
					@click="isDrillDown = !isDrillDown">
					<b-icon icon="sort-down" />
					Drill Down Data
				</b-button>

				<b-row class="mx-0 my-3" v-show="!isDrillDown" align-v="center">
					<b-col class="p-0" cols="2">
						<label class="font-weight-bold">Pilih Kategori Data: </label>
					</b-col>
					<b-col class="p-0" cols="3">
						<b-form-select v-model="selectedAxis" size="sm">
							<b-form-select-option :value="null" disabled>
								-- Pilih salah satu kategori --
							</b-form-select-option>
							<b-form-select-option v-for="(item, idx) in axisCategories" :value="item.key" :key="idx">
								{{ item.value }}
							</b-form-select-option>
						</b-form-select>
					</b-col>
				</b-row>

				<b-row class="mx-0 my-3" v-show="!isDrillDown" align-v="start">
					<b-col class="p-0" cols="2">
						<label class="font-weight-bold">Daftar Series Data : </label>
					</b-col>
					<b-col class="p-0" cols="8">
						<b-form-select v-model="selectedDataSeries" size="sm">
							<b-form-select-option :value="null" disabled>
								-- Pilih salah satu series data --
							</b-form-select-option>
							<b-form-select-option v-for="(item, idx) in seriesList" :value="item" :key="idx">
								<template v-for="(item2, idx2) in item">
									<template v-if="idx2 > 0">
										-
										{{ capitalizeEachWord(item2[2]) }}
									</template>
									<template v-else>
										{{ capitalizeEachWord(item2[2]) }}
									</template>
								</template>
							</b-form-select-option>
						</b-form-select>
						<br />
						<div class="mt-1">
							<span style="font-size: 0.8rem">{{ dataSeriesStructure }}</span>
						</div>
					</b-col>
				</b-row>

				<b-card class="my-3 w-50" v-show="isSeriesList && !isDrillDown"
					style="border: 1px solid rgb(23, 162, 184) !important">
					<b-list-group class="m-0" style="max-height: 250px; overflow-y: auto">
						<b-list-group-item v-for="(item, idx) in seriesList" :key="idx" class="py-2 px-3">
							<b-row class="p-0">
								<b-col md="10" style="word-wrap: break-word">
									<template v-for="(item2, idx2) in item">
										<template v-if="idx2 > 0">
											-
											{{ capitalizeEachWord(item2[2]) }}
										</template>
										<template v-else>
											{{ capitalizeEachWord(item2[2]) }}
										</template>
									</template>
								</b-col>
								<b-col h-align="right" md="2">
									<b-form-checkbox v-model="seriesListVisibility[idx]" class="ml-2" switch>
									</b-form-checkbox>
								</b-col>
							</b-row>
						</b-list-group-item>
					</b-list-group>
				</b-card>

				<b-card v-show="isDrillDown" no-body class="my-3" style="width: 400px">
					<b-card-header class="td-bg-blue text-light font-weight-bold">
						<b-icon icon="layout-three-columns" rotate="90" />
						Drill Down Level
					</b-card-header>

					<b-card-body id="pie-chart-dropzone-item" @drop="onDrop($event)" @dragover.prevent
						@dragenter.prevent class="pt-3 pb-0">
						<div :id="'pie-chart-dropzone-item-fields-' + item" class="
								td-border-grey td-border-solid td-border-thin td-cursor-move
								py-2
								px-2
								my-2
								draggable-fields
							" v-for="item in drilldownDimensions" :key="item" :data-value="item" draggable @dragstart="startDrag($event)">
							<b-icon class="mr-1 td-text-grey" icon="grid-fill" font-scale="0.8" />
							<template v-if="item === 'indicator'"> Indikator </template>
							<template v-else-if="item === 'region'"> Wilayah </template>
							<template v-else-if="item === 'period'"> Periode </template>

							<template v-else-if="item.startsWith('category')">
								{{ capitalizeEachWord(choosenDimensions[item].name) }}
							</template>
						</div>
					</b-card-body>

					<b-card-text class="text-right" style="padding: 0.5rem 1.25rem">
						<b-button class="td-btn-outline-blue mr-1" pill @click="resetDrillDownLevel">
							Reset <b-icon class="ml-1" icon="arrow-counterclockwise" />
						</b-button>
						<b-button class="td-btn-blue" pill @click="updateDrillDownLevel">
							Update <b-icon class="ml-1" icon="check-circle" />
						</b-button>
					</b-card-text>
				</b-card>

				<b-row class="text-right">
					<b-col />
					<b-col>
						<b-button-group class="mr-3">
							<b-button :class="pieMode === 'pie' ? 'td-btn-teal' : 'td-btn-outline-teal'
								" :disabled="!isDrillDown && selectedDataSeries === null" @click="pieMode = 'pie'">
								<b-icon icon="pie-chart-fill" />
								Pie
							</b-button>

							<b-button :class="pieMode === 'doughnut' ? 'td-btn-teal' : 'td-btn-outline-teal'
								" id="dougnut-menu-bar" :disabled="!isDrillDown && selectedDataSeries === null" @click="pieMode = 'doughnut'">
								<b-iconstack>
									<b-icon stacked icon="circle-fill" scale="1.25" />
									<b-icon :id="pieMode === 'doughnut'
										? 'doughnut-icon-selected'
										: 'doughnut-icon'
										" stacked icon="circle-fill" scale="0.55" />
								</b-iconstack>
								Doughnut
							</b-button>

							<b-button :class="pieMode === 'half-doughnut'
								? 'td-btn-teal'
								: 'td-btn-outline-teal'
								" :disabled="!isDrillDown && selectedDataSeries === null" @click="pieMode = 'half-doughnut'">
								<b-icon icon="circle-half" rotate="90" />
								Semi-Circle Doughnut
							</b-button>
						</b-button-group>

						<b-button-group>
							<b-button :class="'font-weight-bold ' +
								(is3d ? 'td-btn-teal' : 'td-btn-outline-teal')
								" :disabled="!isDrillDown && selectedDataSeries === null" @click="is3d = !is3d">
								3D Rendering
							</b-button>
						</b-button-group>
					</b-col>
				</b-row>

				<div id="pie-chart" class="w-100 mt-4" style="height: auto"></div>

				<b-card class="my-3 flot-right" v-show="is3d" style="width: 450px !important">
					<b-row>
						<b-col cols="5">
							Alpha Angle
							<b-button class="text-decoration-none" variant="link" v-b-tooltip.hover
								title="Reset Alpha Angle" @click="alpha3d = 45">
								<b-icon icon="arrow-counterclockwise" />
							</b-button>
						</b-col>
						<b-col class="px-0" cols="5">
							<b-form-input v-model="alpha3d" type="range" min="-60" max="60" />
						</b-col>
						<b-col cols="2">
							{{ alpha3d }}
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="5">
							Beta Angle
							<b-button class="text-decoration-none" variant="link" v-b-tooltip.hover
								title="Reset Beta Angle" @click="beta3d = 0">
								<b-icon icon="arrow-counterclockwise" />
							</b-button>
						</b-col>
						<b-col class="px-0" cols="5">
							<b-form-input v-model="beta3d" type="range" min="-60" max="60" />
						</b-col>
						<b-col cols="2">
							{{ beta3d }}
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="5">
							Depth
							<b-button class="text-decoration-none" variant="link" v-b-tooltip.hover title="Reset Depth"
								@click="depth3d = 35">
								<b-icon icon="arrow-counterclockwise" />
							</b-button>
						</b-col>
						<b-col class="px-0" cols="5">
							<b-form-input v-model="depth3d" type="range" min="20" max="50" />
						</b-col>
						<b-col cols="2">
							{{ depth3d }}
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="5" />
						<b-col class="text-right" cols="5">
							<b-button class="td-btn-blue" pill @click="
								alpha3d = 45;
							beta3d = 0;
							depth3d = 35;
							">
								Reset All
							</b-button>
						</b-col>
					</b-row>
				</b-card>
			</b-card-text>
		</b-card>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
var Highcharts = require("highcharts");
require("highcharts/modules/drilldown")(Highcharts);
require("highcharts/highcharts-3d")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
import utils from "../../../../../../../utils/TabelDinamisUtils";

//local registration for output component
export default {
	name: "VisualizationPieChart",
	data() {
		return {
			selectedAxis: null,
			selectedDataSeries: null,
			selectedSecondAxis: null,
			categories: [],
			seriesList: [],
			seriesListVisibility: [],
			seriesData: [],
			isSeriesList: false,
			tempData: [],
			backupData: [],
			pieChart: null,
			pieMode: "pie",
			is3d: false,
			alpha3d: 45,
			beta3d: 0,
			depth3d: 35,
			isDrillDown: false,
			drilldownDimensions: [],
			backupDrilldownDimensions: [],
		};
	},
	props: ["choosenDimensions", "choosenData", "datasetName"],
	created() { },
	destroyed() { },
	mounted: function () { },
	computed: {
		axisCategories() {
			return Object.entries(this.choosenDimensions)
				.map(([k, v]) => {
					return { key: k, value: utils.capitalizeEachWord(v.name) };
				})
				.filter((v) => {
					return v.value !== "";
				});
		},
		seriesListLen() {
			return this.seriesList.length;
		},
		dataSeriesStructure() {
			let len;
			let temp = "";

			if (this.selectedAxis !== null && this.selectedSecondAxis !== null) {
				len = this.selectedSecondAxis.length;

				if (len > 0) {
					for (let i = 0; i < len; i++) {
						temp +=
							"[" +
							utils.capitalizeEachWord(
								this.choosenDimensions[this.selectedSecondAxis[i]].name
							) +
							"]";
						if (i < len - 1) {
							temp += " - ";
						}
					}
				}
			}

			return temp;
		},
		pieChartTitle() {
			let temp = "";
			if (this.selectedDataSeries !== null) {
				let selectedDataSeriesLen = this.selectedDataSeries.length;
				this.selectedDataSeries.forEach((item, idx) => {
					temp += item[2];
					if (idx < selectedDataSeriesLen - 1) {
						temp += "-";
					}
				});
			}
			return temp;
		},
		drilldownDimensionsLen() {
			return this.drilldownDimensions.length;
		},
	},
	watch: {
		choosenData(newVal, oldVal) {
			if (newVal !== oldVal) {
				if (this.pieChart !== null) {
					this.pieChart.destroy();
					this.pieChart = null;
				}
				this.backupData = [];
				this.tempData = [];
				this.selectedAxis = null;
				this.seriesList = [];
				this.selectedSecondAxis = null;
				this.selectedDataSeries = null;
				this.isDrillDown = false;
				this.initializeDrillDownLevel();

				//this.pieChart = null;
			}
		},
		selectedAxis(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.pieMode = "pie";
				this.is3d = false;
				this.alpha3d = 45;
				this.beta3d = 0;
				this.depth3d = 35;
				this.selectedDataSeries = null;

				if (newVal !== null) {
					this.initializeTempData();
					this.setCategories();
					this.setSelectedSecondAxis();

					const selectedSecondAxisCategoryArray = [];
					this.setSelectedSecondAxisCategoryArray(
						selectedSecondAxisCategoryArray
					);

					let getCombination = function (array, prefix) {
						prefix = prefix || "";

						if (!array.length) {
							return prefix.slice(0, -1);
						}

						var result = array[0].reduce(function (result, value) {
							return result.concat(
								getCombination(array.slice(1), prefix + value + "¸")
							);
						}, []);

						return result;
					};

					let selectedSecondAxisCategoryArrayCombination = getCombination(
						selectedSecondAxisCategoryArray
					);

					this.seriesList = Object.values(
						selectedSecondAxisCategoryArrayCombination
					).map((val) => {
						return this.setFilters(val);
					});

					this.seriesData = [];

					if (this.pieChart !== null) {
						this.pieChart.destroy();
						this.pieChart = null;
					}
				} else if (newVal === null) {
					this.resetCategories();
				}
			}
		},
		selectedDataSeries(newVal, oldVal) {
			if (newVal !== oldVal) {
				if (newVal !== null) {
					this.is3d = false;
					this.alpha3d = 45;
					this.beta3d = 0;
					this.depth3d = 35;
					this.pieMode = "pie";

					let data = [];
					this.seriesData = [];

					Object.values(
						this.choosenDimensions[this.selectedAxis].selectedItem
					).forEach((value) => {
						let temp = [];
						temp.push(this.selectedAxis);
						temp.push("" + value.id);

						let temp2 = JSON.parse(JSON.stringify(this.selectedDataSeries));
						temp2.push(temp);

						let y = this.validateTempData(temp2);

						let datum = {
							name: value.name,
							y: y,
						};

						data.push(datum);
					});

					this.seriesData = [
						{
							data: data,
						},
					];

					if (this.pieChart !== null) {
						this.pieChart.destroy();
					}

					this.generatePieChart();
				}
			}
		},
		pieMode: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal && this.pieChart !== null) {
					let tempSeriesData = JSON.parse(JSON.stringify(this.seriesData));

					if (!this.isDrillDown) {
						switch (newVal) {
							case "pie": {
								tempSeriesData[0].innerSize = "0%";
								this.seriesData = JSON.parse(JSON.stringify(tempSeriesData));

								this.pieChart.update(
									{
										chart: {
											options3d: {
												enabled: this.is3d,
											},
										},
										series: this.seriesData,
										plotOptions: {
											pie: {
												startAngle: 0,
												endAngle: 0,
											},
										},
									},
									true
								);

								break;
							}

							case "doughnut": {
								tempSeriesData[0].innerSize = "50%";
								this.seriesData = JSON.parse(JSON.stringify(tempSeriesData));

								this.pieChart.update(
									{
										series: this.seriesData,
										plotOptions: {
											pie: {
												startAngle: 0,
												endAngle: 0,
											},
										},
									},
									true
								);

								this.pieChart.update(
									{
										chart: {
											options3d: {
												enabled: this.is3d,
											},
										},
									},
									false
								);

								break;
							}

							case "half-doughnut": {
								tempSeriesData[0].innerSize = "50%";
								this.seriesData = JSON.parse(JSON.stringify(tempSeriesData));

								this.pieChart.update(
									{
										chart: {
											options3d: {
												enabled: this.is3d,
											},
										},
										series: this.seriesData,
										plotOptions: {
											pie: {
												startAngle: -90,
												endAngle: 90,
											},
										},
									},
									true
								);

								break;
							}
						}

						// this.pieChart.redraw();
					} else {
						this.generatePieChart();
					}
				}
			},
		},
		is3d: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal && this.pieChart !== null) {
					this.pieChart.update(
						{
							chart: {
								options3d: {
									enabled: newVal,
								},
							},
						},
						false
					);

					this.pieChart.redraw();
				}
			},
		},
		alpha3d(newVal, oldVal) {
			if (newVal !== oldVal && this.pieChart !== null) {
				this.pieChart.update(
					{
						chart: {
							options3d: {
								enabled: false,
								alpha: newVal,
							},
						},
					},
					true
				);

				this.pieChart.update(
					{
						chart: {
							options3d: {
								enabled: true,
							},
						},
					},
					true
				);
			}
		},
		beta3d(newVal, oldVal) {
			if (newVal !== oldVal && this.pieChart !== null) {
				this.pieChart.update(
					{
						chart: {
							options3d: {
								enabled: false,
								beta: newVal,
							},
						},
					},
					true
				);

				this.pieChart.update(
					{
						chart: {
							options3d: {
								enabled: true,
							},
						},
					},
					true
				);
			}
		},
		depth3d(newVal, oldVal) {
			if (newVal !== oldVal && this.pieChart !== null) {
				this.pieChart.update(
					{
						plotOptions: {
							pie: { depth: this.depth3d },
						},
					},
					false
				);

				this.pieChart.redraw();
			}
		},
		isDrillDown(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.isGrouped = true;
				this.initializeTempData();
				this.generatePieChart();
			}
		},
	},
	methods: {
		capitalizeEachWord(str) {
			return utils.capitalizeEachWord(str);
		},
		startDrag(evt) {
			evt.dataTransfer.dropEffect = "move";
			evt.dataTransfer.effectAllowed = "move";
			evt.dataTransfer.setData("item", evt.target.id);
		},
		onDrop(evt) {
			evt.preventDefault();
			let item = evt.dataTransfer.getData("item");

			if (evt.target.id === "pie-chart-dropzone-item") {
				document
					.getElementById(evt.target.id)
					.appendChild(document.getElementById(item));
			} else {
				if (evt.target.id !== item) {
					if (
						evt.currentTarget.id !== document.getElementById(item).parentNode.id
					) {
						document
							.getElementById(evt.currentTarget.id)
							.insertBefore(
								document.getElementById(item),
								document.getElementById(evt.target.id)
							);
					} else {
						let childrenNodesDropzone = document.getElementById(
							evt.currentTarget.id
						).children;

						let idxItem = Array.from(childrenNodesDropzone).indexOf(
							document.getElementById(item)
						);

						let idxTargetId = Array.from(childrenNodesDropzone).indexOf(
							document.getElementById(evt.target.id)
						);

						if (idxItem < idxTargetId) {
							if (idxTargetId === childrenNodesDropzone.length - 1) {
								document
									.getElementById(evt.currentTarget.id)
									.insertBefore(document.getElementById(item), null);
							} else {
								document
									.getElementById(evt.currentTarget.id)
									.insertBefore(
										document.getElementById(item),
										document.getElementById(
											childrenNodesDropzone[idxTargetId + 1].id
										)
									);
							}
						} else {
							document
								.getElementById(evt.currentTarget.id)
								.insertBefore(
									document.getElementById(item),
									document.getElementById(childrenNodesDropzone[idxTargetId].id)
								);
						}
					}
				}
			}
		},
		initializeTempData() {
			//set temp data by transform response.data if backupdata hasnot been set, else temp data is assigned by backup data
			if (this.backupData.length === 0) {
				let tempData = Object.values(this.choosenData).map((value) => {
					let data = {
						value: value.value,
						period: value.period,
						region: value.region.itemCategoryId,
						indicator: value.indicator.indicatorId,
					};
					Object.keys(value).forEach((key) => {
						if (
							key.startsWith("itemCategory") &&
							value[key].itemCategoryId > 0
						) {
							let itemCategory = {
								["category" + key.slice(key.length - 1)]:
									value[key].itemCategoryId,
							};
							data = { ...data, ...itemCategory };
						}
					});

					return data;
				});

				this.tempData = tempData;
				this.backupData = JSON.parse(JSON.stringify(this.tempData));
			} else {
				this.tempData = JSON.parse(JSON.stringify(this.backupData));
			}
		},
		initializeDrillDownLevel() {
			this.drilldownDimensions = [];
			this.drilldownDimensions.push("indicator");

			Object.keys(this.choosenDimensions).forEach((key) => {
				if (
					key.startsWith("category") &&
					this.choosenDimensions[key].selectedItem.length > 0
				) {
					this.drilldownDimensions.push(key);
				}
			});

			this.drilldownDimensions.push("region");
			this.drilldownDimensions.push("period");

			this.backupDrilldownDimensions = this.drilldownDimensions;
		},
		setCategories() {
			this.categories = this.choosenDimensions[
				this.selectedAxis
			].selectedItem.map((item) => {
				return item.name;
			});
		},
		resetCategories() {
			this.categories = [];
		},
		setSelectedSecondAxis() {
			this.selectedSecondAxis = [];

			Object.keys(this.choosenDimensions).forEach((key) => {
				if (
					this.choosenDimensions[key].name !== "" &&
					key !== this.selectedAxis
				) {
					this.selectedSecondAxis.push(key);
				}
			});
		},
		setSelectedSecondAxisCategoryArray(val) {
			return Object.values(this.selectedSecondAxis).forEach((value) => {
				const dimensionItems = this.choosenDimensions[value].selectedItem.map(
					(item) => {
						return value + "—" + item.id + "—" + item.name;
					}
				);

				val.push(dimensionItems);
			});
		},
		setFilters(val) {
			return Object.values(val.split("¸")).map((value) => {
				return value.split("—");
			});
		},
		validateTempData(filters) {
			let dataFound = null;

			for (let i in this.tempData) {
				let value = this.tempData[i];
				let result = "success";

				for (let i = 0, filtersLen = filters.length; i < filtersLen; i++) {
					if (filters[i][0] === "period") {
						if (value[filters[i][0]] !== filters[i][1]) {
							result = "fail";
							break;
						}
					} else {
						if (value[filters[i][0]] !== parseInt(filters[i][1])) {
							result = "fail";
							break;
						}
					}
				}

				if (result === "success") {
					dataFound = value.value === "..." ? null : value.value;

					delete this.tempData[i];
					break;
				}
			}

			return dataFound;
		},
		onClickSelectSeriesList(option) {
			let len = this.seriesListVisibility.length;
			let temp = [];

			switch (option) {
				case "selectAll":
					for (let i = 0; i < len; i++) {
						temp[i] = true;
					}
					break;
				case "unselectAll":
					for (let i = 0; i < len; i++) {
						temp[i] = false;
					}
					break;
			}

			this.seriesListVisibility = JSON.parse(JSON.stringify(temp));
		},
		generatePieChart() {
			let seriesDataAndDrillDown = [];

			if (this.isDrillDown) {
				this.setSeriesDataAndDrillDown(seriesDataAndDrillDown);
			}

			this.pieChart = Highcharts.chart("pie-chart", {
				chart: {
					type: "pie",
					borderColor: "grey",
					borderWidth: 1,
					borderRadius: 10,
					spacing: [25, 30, 25, 30],
					height: 500,
					options3d: {
						enabled: this.is3d,
						alpha: this.alpha3d,
						beta: this.beta3d,
					},
				},
				title: {
					text: this.pieChartTitle,
				},
				subtitle: {
					text: "",
				},
				tooltip: {
					pointFormat: "<b>{point.y:.0f}</b>",
				},
				accessibility: {
					point: {
						valueSuffix: "%",
					},
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: "pointer",
						dataLabels: {
							enabled: true,
							format: "<b>{point.name}</b>: {point.percentage:.1f} %",
						},
						depth: this.depth3d,
						startAngle: this.pieMode === "half-doughnut" ? -90 : null,
						endAngle: this.pieMode === "half-doughnut" ? 90 : null,
					},
				},
				legend: {
					// layout: "vertical",
					// align: "right",
					// verticalAlign: "top",
					// x: -40,
					// y: 100,
					maxHeight: 100,
					floating: false,
					borderWidth: 1,
					backgroundColor:
						Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
					shadow: true,
				},
				credits: {
					enabled: false,
				},
				series: this.isDrillDown
					? [
						{
							colorByPoint: true,
							innerSize:
								this.pieMode === "doughnut" ||
									this.pieMode === "half-doughnut"
									? "50%"
									: null,
							data: seriesDataAndDrillDown[0],
						},
					]
					: this.seriesData,
				drilldown: {
					breadcrumbs: {
						position: {
							align: "right",
						},
					},
					series: this.isDrillDown
						? this.pieMode === "doughnut" || this.pieMode === "half-doughnut"
							? seriesDataAndDrillDown[1].map((item) => {
								item.innerSize = "50%";
								return item;
							})
							: seriesDataAndDrillDown[1].map((item) => {
								item.innerSize = "0%";
								return item;
							})
						: null,
				},
			});
		},
		setSeriesDataAndDrillDown(seriesDataAndDrillDown) {
			let seriesData = [],
				seriesDrillDown = [],
				transferedData = [];

			for (let i = 0; i < this.drilldownDimensionsLen + 1; i++) {
				if (i === 0) {
					seriesData = this.constructDrillDownSeriesData(
						i,
						this.tempData,
						transferedData
					);
				} else if (i === 1) {
					seriesData.forEach((itemSeries) => {
						let drillDownWrapper = this.constructDrillDownWrapper(
							itemSeries.name,
							itemSeries.drilldown,
							i,
							itemSeries
						);

						transferedData.push(drillDownWrapper);

						delete itemSeries.data;
					});

					seriesDrillDown = [...seriesDrillDown, ...transferedData];
				} else if (i !== 1 && i < this.drilldownDimensionsLen - 1) {
					let tempData = transferedData;
					transferedData = [];

					tempData.forEach((tempItemSeries) => {
						tempItemSeries.data.forEach((itemSeries) => {
							let drillDownWrapper = this.constructDrillDownWrapper(
								itemSeries.name,
								itemSeries.drilldown,
								i,
								itemSeries
							);

							transferedData.push(drillDownWrapper);

							delete itemSeries.data;
						});
					});

					seriesDrillDown = [...seriesDrillDown, ...transferedData];
				} else if (i === this.drilldownDimensionsLen - 1) {
					let tempData = transferedData;
					transferedData = [];

					tempData.forEach((tempItemSeries) => {
						tempItemSeries.data.forEach((itemSeries) => {
							let drillDownWrapper = this.constructDrillDownWrapper(
								itemSeries.name,
								itemSeries.drilldown,
								i,
								itemSeries
							);

							transferedData.push(drillDownWrapper);

							delete itemSeries.data;
						});
					});

					seriesDrillDown = [...seriesDrillDown, ...transferedData];
				}
			}

			seriesDataAndDrillDown[0] = seriesData;
			seriesDataAndDrillDown[1] = seriesDrillDown;
		},
		constructDrillDownSeriesData(i, originData) {
			let outputData = [];

			this.choosenDimensions[this.drilldownDimensions[i]].selectedItem.forEach(
				(item) => {
					if (i < this.drilldownDimensionsLen - 1) {
						let filteredTempData = (
							i === 0 ? originData : originData.data
						).filter((data) => data[this.drilldownDimensions[i]] === item.id);

						let output = {
							y: filteredTempData.reduce(function (previousVal, currentVal) {
								return (
									previousVal +
									(currentVal.value === "..." ? 0 : currentVal.value)
								);
							}, 0),
							data: filteredTempData,
							name: item.name,
							drilldown:
								i === 0 ? item.id : originData.drilldown + "-" + item.id,
						};

						outputData.push(output);
					} else {
						this.choosenDimensions[
							this.drilldownDimensions[i]
						].selectedItem.forEach((item) => {
							let temp = originData.data.find(
								(data) => data[this.drilldownDimensions[i]] === item.id
							);
							outputData.push([
								item.name,
								temp.value === "..." ? 0 : temp.value,
							]);
						});
					}
				}
			);

			return outputData;
		},
		constructDrillDownWrapper(name, id, i, itemSeries) {
			return {
				colorByPoint: true,
				name: name,
				id: id,
				data: this.constructDrillDownSeriesData(i, itemSeries),
			};
		},
		updateDrillDownLevel() {
			let temp = [];

			let dropzoneItems = document.getElementById(
				"pie-chart-dropzone-item"
			).children;

			temp = Object.values(dropzoneItems).map((item) => {
				return item.getAttribute("data-value");
			});

			if (!utils.arraysEqual(temp, this.drilldownDimensions)) {
				this.drilldownDimensions = temp;

				this.generatePieChart();
			}
		},
		resetDrillDownLevel() {
			let temp = [];

			let dropzoneItems = document.getElementById(
				"pie-chart-dropzone-item"
			).children;

			temp = Object.values(dropzoneItems).map((item) => {
				return item.getAttribute("data-value");
			});

			if (!utils.arraysEqual(temp, this.backupDrilldownDimensions)) {
				this.drilldownDimensions = [];

				setTimeout(
					function () {
						this.drilldownDimensions = JSON.parse(
							JSON.stringify(this.backupDrilldownDimensions)
						);

						this.generatePieChart();
					}.bind(this),
					0
				);

				/* for (
					let i = 0, backupLen = this.backupDrilldownDimensions.length;
					i < backupLen;
					i++
				) {
					this.$set(
						this.drilldownDimensions,
						i,
						this.backupDrilldownDimensions[i]
					);
				} */

				this.generatePieChart();
			}
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";

#doughnut-icon {
	color: white !important;
}

#dougnut-menu-bar:hover #doughnut-icon,
#doughnut-icon-selected {
	@extend .td-text-teal;
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 15-03-2023 -->
